if (!customElements.get('site-accordion')) {
  customElements.define(
    'site-accordion',
    class Accordion extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('.accordion__title');
        /**
         * @type {HTMLElement | null}
         */
        this.content = this.querySelector('.accordion__content');

        this.button?.addEventListener('click', this.handleClick.bind(this));
      }

      /**
       * @param {MouseEvent} event
       */
      handleClick(event) {
        event.preventDefault();

        if (this.isOpen) {
          this.handleClose(this);
        } else {
          this.handleOpen();
        }
      }

      handleOpen() {
        if (!this.content) return;

        this.content?.setAttribute('aria-hidden', 'false');
        this.style.setProperty('--accordion-content-height', `${this.content.offsetHeight + 20}px`);
        this.setAttribute('open', 'true');
        this.groupName && this.closeOtherAccordions();
        const button = this.querySelector('.accordion__title');
        if(button.dataset.triggerpdp){
          gtag('event', 'pdp_engagements', {
            'event_action': button.dataset.title,
            'event_label': button.dataset.variant ? button.dataset.variant : null,
          });
        }
      }

      /**
       * @param {HTMLElement} accordion
       */
      handleClose(accordion) {
        const content = accordion.querySelector('.accordion__content');
        content?.setAttribute('aria-hidden', 'true');
        accordion.removeAttribute('open');
      }

      closeOtherAccordions() {
        this.groupAccordions.forEach((accordion) => {
          if (accordion !== this) {
            this.handleClose(accordion);
          }
        });
      }

      get isOpen() {
        return this.hasAttribute('open');
      }

      get groupName() {
        return this.dataset.group ? this.dataset.group : false;
      }

      /**
       * @type {NodeListOf<HTMLElement>}
       */
      get groupAccordions() {
        return document.querySelectorAll(`.accordion[data-group="${this.groupName}"]`);
      }
    },
  );
}
